'use client';

import { ReactElement } from 'react';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import { HeaderUtilityMenu } from '../../montefiore/header/header-utility-menu';
import {
  MEACFlyoutHeadlineSubtitle,
  MEACUtilityRightMenu,
  buildMEACFlyoutHeadline,
  buildMEACFlyoutMenu,
} from './header-data';
import { HeaderMainMenu } from './header-main-menu';
import { HeaderSecondaryMenu } from './header-secondary-menu';

import '../../montefiore/montefiore.css';

export const MEACHeader = (): ReactElement => {
  const { config } = useOrgContext();
  const flyoutHeadline = buildMEACFlyoutHeadline(config.companyUrl);
  const flyoutMenu = buildMEACFlyoutMenu(config.companyUrl);

  return (
    <div
      id={'block-navigation'}
      className={'block-meda-blocks block-navigation block print:hidden'}
    >
      <header className={'mf-navigation'}>
        <div className={'relative z-10'}>
          <div className={'mf-top-bar mf-top-bar--site-montefiore'}>
            <HeaderUtilityMenu
              leftLinks={[]}
              rightLinks={MEACUtilityRightMenu}
            />
            <HeaderMainMenu />
          </div>
          <HeaderSecondaryMenu
            headline={flyoutHeadline}
            headlineSubtitle={MEACFlyoutHeadlineSubtitle}
            flyoutMenu={flyoutMenu}
          />
        </div>
      </header>
    </div>
  );
};
